exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "thead.v-data-table-header>tr>th>div[data-v-2eee68d2]{display:inline-block;width:90%;margin-right:3px}[data-v-2eee68d2] thead.v-data-table-header>tr>th>div.v-input label{font-size:12px!important;font-weight:400}", ""]);

// exports
